import { Injectable } from '@tanbo/vue-di-plugin'
import { Subject } from 'rxjs'
import { SettingsRes } from '@/views/dashboard/_components/group-policy-settings/group-policy-settings.service'

export enum OperateType {
  edit = 'edit',
  add = 'add',
  read = 'read'
}

@Injectable()
export class GroupPolicyDrawerService {
  /** 当前需求逻辑设计奇怪，这里使用订阅发布共享策略全局数据（如：name） */
  onChangePolicyData = new Subject<SettingsRes>()
  policyData = {} as SettingsRes

  changePolicyData (data: SettingsRes) {
    this.policyData = data
    this.onChangePolicyData.next(data)
  }
}
